export default function initCatalogColumns() {
    const filter = document.querySelector('.catalog-sort__item.columns-count')
    const catalogList = document.querySelector('.catalog__list')
    if (filter) {
        filter.addEventListener('click', (event) => {
            if(event.target.classList.contains('catalog-sort__item-single')) {
                filter.classList.add('single')
                catalogList.classList.add('single')
            } else if (event.target.classList.contains('catalog-sort__item-duo')) {
                catalogList.classList.remove('single')
                filter.classList.remove('single')
            }
        })
    }

}




// WEBPACK FOOTER //
// ./src/js/catalogColumns.js